import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../root-redux/RootState";
import { postSPARequestServiceAPI } from "./PostSPARequest";
import { getSPARequestServiceAPI } from "./GetSPARequest";

type requestType = { campaignWorkflowId: string, mesage: string };

export const postAgentMessage = createAsyncThunk<any, requestType, { state: RootState }>('campaignagent/postAgentMessage', async (request: requestType, {getState, dispatch, rejectWithValue}) => {
    const threadId = getState().campaignAgent.threadId;
    const selectedEnv = getState().env.selectedEnvItem;
    const response = await postSPARequestServiceAPI<any, any>(`api/Campaign/${request.campaignWorkflowId}/chat`, {
        threadId: threadId,
        userPrompt: request.mesage
    }, selectedEnv);
    
    return response.data;
});

export const generateOnePageSummary = createAsyncThunk<any, string, { state: RootState }>('campaignagent/generateOnePageSummary', async (id: string, {getState, dispatch, rejectWithValue}) => {
    const selectedEnv = getState().env.selectedEnvItem;
    const response = await getSPARequestServiceAPI<any>(`api/Campaign/${id}/onepagesummary`, selectedEnv);
    return response.data;
});